module.exports = Em.Route.extend({
    include: 'contact.city,contact.state,contact.zipcode',

    setupController: function(controller) {
        this._super.apply(this, arguments)
        controller.get('balances').invalidate()
    }
})
